<template>
    <div class="modal fade" id="div-otp-mail-choosing" tabindex="-1" aria-labelledby="informLabel" aria-hidden="true">
        <div class="modal-dialog">
            <div class="modal-content rounded-lg">
                <div class="modal-header border-bottom-0 position-relative">
                    <h4 class="modal-title text-left w-100 pr-4">ご本人確認のためのワンタイムパスワード認証</h4>
                    <button type="button" class="close modal-close-btn" data-dismiss="modal" aria-label="Close" @click="closeModal()">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body pt-0">
                    <div class="text-left fs-14px mb-5">
                        ご本人確認のためご登録のメールアドレス宛にワンタイムパスワードを送信いたします。<br>
                        <span v-if="this.params.otpMail2">
                        以下より、送信先を選択してください。
                        </span>
                    </div>

                    <div class="mail-list text-left fs-13px mb-5">
                        <div class="float-left w-100" v-if="this.params.otpMail1">
                            <label class="mail-item word-break-all">
                                <input class="radio-mail-type" type="radio" value="1" v-model="mailTypeSelected" checked>
                                <span class="ml-4">メインメール</span>
                                <span>（{{this.params.otpMail1}}）</span>
                            </label>
                        </div>
                        <div class="float-left w-100" v-if="this.params.otpMail2">
                            <label class="mail-item word-break-all">
                                <input class="radio-mail-type" type="radio" value="2" v-model="mailTypeSelected">
                                <span class="ml-4">追加メール</span>
                                <span>（{{this.params.otpMail2}}）</span>
                            </label>
                        </div>
                        <div class="clearfix"></div>
                    </div>

                    <div class="notice text-left fs-14px">
                        ご注意事項<br>
                        ・ワンタイムパスワードの有効時間は{{this.params.otpDuration}}分間です。<br>
                        ・メールが届かない場合は、迷惑メールフォルダをご確認ください。
                    </div>
                </div>
                <div class="modal-footer border-top-0 pt-0">
                    <div class="row w-100 justify-content-center">
                        <div class="col-12 col-sm-7 col-lg-6 mb-2">
                            <button class="btn btn-sm btn-primary w-100" @click.prevent="sendOtp()">
                                ワンタイムパスワードを送信する
                            </button>
                        </div>
                        <div class="col-12 col-sm-3">
                            <button class="btn btn-sm btn-default w-100" @click="closeModal()">
                                キャンセル
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import $ from "jquery";
    import ModalPlugin from "@/common/plugins/ModalPlugin.js";
    import IConstants from '@/common/constants/IConstants';
    import ServiceUtils from '@/common/utils/ServiceUtils';

    export default {
        name: "OtpMailChoosing",
        data() {
            return {
                params: {
                    otpDigits: null,
                    otpCountDown: null,
                    otpDuration: null,
                    otpMail1: null,
                    otpMail2: null,
                    screenName: null
                },
                mailTypeSelected: '1'
            }
        },
        mounted() {
            this.onOpenEvent()
        },
        methods: {
            onOpenEvent() {
                ModalPlugin.EventBus.$on(this.IConstants.EVENT_NAME.SHOW_OTP_MAIL_CHOOSING, (params) => {
                    $('#div-otp-mail-choosing').modal({backdrop: 'static', keyboard: false});
                    this.params = params;
                    this.initHTMLDefault()
                    $("#div-otp-mail-choosing").modal("show");
                });
            },
            initHTMLDefault() {
                this.mailTypeSelected = '1'
            },
            async sendOtp() {
                await this.$service
                    .getService(IConstants.SERVICE_NAME.FIDO)
                    .sendAuthenticateOtp(this.params.screenName, this.mailTypeSelected)
                    .then(async () => {
                        // ignore send-OTP errors and always display the OTP input screen. Users can resend the OTP afterward
                        await this.closeModal();
                        this.$modal.showOtpInput({
                            ...this.params,
                            mailTypeSelected: this.mailTypeSelected,
                            otpMail: this.getMailFromMailType()
                        })
                    })
            },
            getMailFromMailType() {
                if (String(this.mailTypeSelected) === String(IConstants.MAIL_OTP.MAIN_MAIL)) return this.params.otpMail1
                if (String(this.mailTypeSelected) === String(IConstants.MAIL_OTP.ADDITIONAL_MAIL)) return this.params.otpMail2
                return ''
            },
            async closeModal() {
                await ServiceUtils.waitModalFullyHidden($('#div-otp-mail-choosing'));
            },
        }
    }
</script>

<style scoped>
    .modal-dialog {
        max-width: 800px;
    }

    .modal-close-btn {
        position: absolute;
        top: 1rem;
        right: 1rem;
    }

    .radio-mail-type {
        accent-color: #555;
    }

    .btn-default {
      border: 1px solid rgba(0, 0, 0, .4);
    }
</style>
